module.exports = __webpack_public_path__ + "static/icon-driver-requirement-224e387fde03a006db13fc72387e9649.png";